import React from 'react'
import copy from 'copy-to-clipboard'
import { showBanner } from 'workflow/common/common.actions'

import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { Copy } from 'common/icons'

import SectionTitle from './SectionTitle'

const Info = () => {
  const dispatch = useAppDispatch()
  const campaign = useAppSelector((state) => state.campaignStates)

  const { projectId, campaignData } = campaign
  const { _id, user_id, account_id } = campaignData

  const data = [
    `User id: ${user_id}`,
    `Project id: ${projectId}`,
    `Experiment id: ${_id}`,
    `Account id: ${account_id}`,
  ]

  const copyToClipboard = () => {
    copy(data.join(', '))
    dispatch(
      showBanner({
        type: 'success',
        content: 'Experiment info copied successfully',
      })
    )
  }

  return (
    <div className="flex flex-col py-6 pr-6">
      <div className="flex justify-between items-start">
        <SectionTitle>Experiment info</SectionTitle>
        <button
          className="block"
          onClick={() => {
            copyToClipboard()
          }}
        >
          <Copy />
        </button>
      </div>

      <ul className="text-coolGray-800 opacity-60">
        {data.map((item) => {
          return (
            <li
              key={item}
              data-cy={`campaign-info-${
                item.toLowerCase().replace(' ', '-').split(':')[0]
              }`}
              className="mb-1"
            >
              {item}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Info
